export const SampleData = {
  title: "title",
  iconDef: "",
  links: [
    {
      linkTitle: "title",
      linkURL: "",
    },
    {
      linkTitle: "title",
      linkURL: "",
    },
    {
      linkTitle: "title",
      linkURL: "",
    },
    {
      linkTitle: "title",
      linkURL: "",
    },
  ]
}

export const CoursesData = {
  title: "Day Trading Courses",
  iconDef: "fas fa-book",
  links: [
    {
      linkTitle: "Day Trading Course Library",
      linkURL: "/trading-courses/",
    },
    {
      linkTitle: "Free Intro Class",
      linkURL: "/free-day-trading-class/",
    },
  ]
}

export const LiveEducationData = {
  title: "Live Education",
  iconDef: "fas fa-book",
  links: [
    {
      linkTitle: "Chat Rooms & Stream",
      linkURL: "/day-trading-chat-room/",
    },
    {
      linkTitle: "Mentoring",
      linkURL: "/day-trading-mentor/",
    },
  ]
}

export const BooksData = {
  title: "Books",
  iconDef: "fas fa-book",
  links: [
    {
      linkTitle: "How to Day Trade",
      linkURL: "/books/how-to-day-trade/",
    },
  ]
}

export const HowToJoinData = {
  title: "How to Join",
  iconDef: "fas fa-book",
  links: [
    {
      linkTitle: "Warrior Pro",
      linkURL: "/warrior-pro-info/",
    },
    {
      linkTitle: "Warrior Starter",
      linkURL: "/warrior-starter-info/",
    },
    {
      linkTitle: "Price & Feature Comparison",
      linkURL: "/memberships/",
    },
  ]
}

export const DayTradeDashData = {
  title: "Day Trade Dash",
  iconDef: "fas fa-toolbox",
  links: [
    {
      linkTitle: "Day Trade Dash Software Overview",
      linkURL: "/day-trade-dash/",
    },
    {
      linkTitle: "Stock Market Scanners & News",
      linkURL: "/scanners/",
    },
    {
      linkTitle: "Charts",
      linkURL: "/charts/",
    },
    {
      linkTitle: "News",
      linkURL: "/breaking-news-for-traders/",
    },
  ]
}

export const SimulatorData = {
  title: "Real-Time Trading Simulator",
  iconDef: "fas fa-toolbox",
  links: [
    {
      linkTitle: "Real-Time Trading Simulator",
      linkURL: "/paper-trading/",
    },
  ]
}

export const StrategiesData = {
  title: "Strategies",
  iconDef: "far fa-compass",
  links: [
    {
      linkTitle: "Penny Stocks",
      linkURL: "/penny-stocks/",
    },
    {
      linkTitle: "Momentum",
      linkURL: "/momentum-day-trading-strategy/",
    },
    {
      linkTitle: "Reversal",
      linkURL: "/reversal-trading-strategy/",
    },
    {
      linkTitle: "Gap and Go",
      linkURL: "/gap-go/",
    },
    {
      linkTitle: "Bull Flag",
      linkURL: "/bull-flag-trading/",
    },
    {
      linkTitle: "Swing Trading",
      linkURL: "/swing-trading-strategies/",
    },
  ]
}

export const GuidesData = {
  title: "Guides",
  iconDef: "fas fa-map",
  links: [
    {
      linkTitle: "All FAQ",
      linkURL: "/faq/",
    },
    {
      linkTitle: "How much money do I need to start trading?",
      linkURL: "/how-much-money-do-you-need-to-day-trade/",
    },
    {
      linkTitle: "Day Trading Guide",
      linkURL: "/day-trading/",
    },
    {
      linkTitle: "Options Trading Guide",
      linkURL: "/the-essential-options-trading-guide/",
    },
    {
      linkTitle: "Small Account Guide",
      linkURL: "/small-account-guide/",
    },
    {
      linkTitle: "Stock Broker Guide",
      linkURL: "/stock-broker-essential-guide/",
    },
    {
      linkTitle: "Stock Order Types Guide",
      linkURL: "/stock-order-types/",
    },
    {
      linkTitle: "Swing Trading Guide",
      linkURL: "/swing-trading/",
    },
    {
      linkTitle: "Technical Analysis Guide",
      linkURL: "/technical-analysis/",
    },
    {
      linkTitle: "Trading Terms Guide",
      linkURL: "/day-trading-terminology/",
    },
    {
      linkTitle: "Margin vs. Cash Account",
      linkURL: "/margin-account-vs-cash-account/",
    },
    {
      linkTitle: "Large Cap vs. Small Cap",
      linkURL: "/large-cap-vs-small-cap/",
    },
    {
      linkTitle: "Penny Stock Trading",
      linkURL: "/category/penny-stock-trading/",
    },
    {
      linkTitle: "Day Trading Stocks",
      linkURL: "/category/day-trading-stocks/",
    },
  ]
}

export const HowToData = {
  title: "How To's",
  iconDef: "fas fa-wrench",
  links: [
    {
      linkTitle: "How to Day Trade Without $25k",
      linkURL: "/how-to-day-trade-without-25k/",
    },
    {
      linkTitle: "How to Make a Living Day Trading",
      linkURL: "/how-to-make-a-living-day-trading/",
    },
    {
      linkTitle: "How to Get Around PDT",
      linkURL: "/how-to-get-around-the-pdt-rule/",
    },
    {
      linkTitle: "How to Use Multiple Time Frames",
      linkURL: "/technical-analysis-using-multiple-timeframes/",
    },
    {
      linkTitle: "How to Use Hot Keys",
      linkURL: "/hot-key-video-lesson/",
    },
    {
      linkTitle: "How to Use Scanners",
      linkURL: "/how-to-use-stock-scanners/",
    },
    {
      linkTitle: "How to Short Stocks",
      linkURL: "/how-to-short-stocks/",
    },
  ]
}

export const TerminologyData = {
  title: "Terminology",
  iconDef: "fas fa-university",
  links: [
    {
      linkTitle: "Trading Terms Guide",
      linkURL: "/day-trading-terminology/",
    },
    {
      linkTitle: "Circuit Breaker Halts",
      linkURL: "/circuit-breaker-halts/",
    },
    {
      linkTitle: "Day Trading",
      linkURL: "/day-trade-definition-day-trading-terminology/",
    },
    {
      linkTitle: "Float",
      linkURL: "/float-definition-day-trading-terminology/",
    },
    {
      linkTitle: "Margin Account",
      linkURL: "/margin-account-definition-day-trading-terminology/",
    },
    {
      linkTitle: "MOMO",
      linkURL: "/what-is-momo-trading/",
    },
    {
      linkTitle: "Pattern Day Trader",
      linkURL: "/pattern-day-trader-rule/",
    },
    {
      linkTitle: "Pump and Dump",
      linkURL: "/pump-and-dump-definition-day-trading-terminology/",
    },
    {
      linkTitle: "Relative Volume",
      linkURL: "/relative-volume-day-trading-terminology/",
    },
    {
      linkTitle: "Short Sale Restriction",
      linkURL: "/short-sale-restriction-ssr-fast-explanation/",
    },
    {
      linkTitle: "Short Squeeze",
      linkURL: "/short-squeeze-definition/",
    },
    {
      linkTitle: "VWAP",
      linkURL: "/vwap/",
    },
  ]
}

export const BestOfData = {
  title: "Best of",
  iconDef: "fas fa-trophy",
  links: [
    {
      linkTitle: "Best Online Brokers",
      linkURL: "/best-online-stock-brokers/",
    },
    {
      linkTitle: "Best Free Stock Charts",
      linkURL: "/best-free-stock-charts/",
    },
    {
      linkTitle: "Best Trading Tools",
      linkURL: "/the-5-best-tools-for-day-trading/",
    },
    {
      linkTitle: "Best Day Trading Platforms",
      linkURL: "/best-day-trading-platform/",
    },
    {
      linkTitle: "Best Apps for Day Trading",
      linkURL: "/best-apps-for-day-trading/",
    },
    {
      linkTitle: "Best Day Trading Books",
      linkURL: "/best-day-trading-books/",
    },
    {
      linkTitle: "Best Technical Analysis Books",
      linkURL: "/best-technical-analysis-books/",
    },
    {
      linkTitle: "Best Options Platforms",
      linkURL: "/best-options-trading-platforms/",
    },
    {
      linkTitle: "Best Futures Platforms",
      linkURL: "/best-futures-trading-platforms/",
    },
  ]
}

export const ReviewsData = {
  title: "Reviews",
  iconDef: "fas fa-star",
  links: [
    {
      linkTitle: "TD Ameritrade",
      linkURL: "/ameritrade-review-warrior-trading-reviews/",
    },
    {
      linkTitle: "LightSpeed",
      linkURL: "/lightspeed-trading-review/",
    },
    {
      linkTitle: "CMEG",
      linkURL: "/capital-markets-elite-group-review/",
    },
    {
      linkTitle: "WeBull",
      linkURL: "/webull-review/",
    },
    {
      linkTitle: "Robinhood",
      linkURL: "/robinhood-app-review-real-cost-free-trades/",
    },
    {
      linkTitle: "Trade Ideas",
      linkURL: "/trade-ideas-review/",
    },
    {
      linkTitle: "Benzinga",
      linkURL: "/benzinga-pro-review/",
    },
    {
      linkTitle: "Sterling",
      linkURL: "/sterling-trader-review/",
    },
    {
      linkTitle: "DAS Trader",
      linkURL: "/das-trader-review/",
    },
    {
      linkTitle: "eSignal",
      linkURL: "/esignal-review/",
    },
  ]
}

export const QuotesData = {
  title: "Quotes",
  iconDef: "fas fa-fire",
  links: [
    {
      linkTitle: "Apple (AAPL)",
      linkURL: "/quote/aapl/",
    },
    {
      linkTitle: "Meta (META)",
      linkURL: "/quote/meta/",
    },
    {
      linkTitle: "Tesla (TSLA)",
      linkURL: "/quote/tsla/",
    },
    {
      linkTitle: "Amazon (AMZN)",
      linkURL: "/quote/amzn/",
    },
    {
      linkTitle: "Netflix (NFLX)",
      linkURL: "/quote/nflx/",
    },
    {
      linkTitle: "Google (GOOGL)",
      linkURL: "/quote/googl/",
    },
  ]
}

export const AdditionalResourcesData = {
  title: "Additional Resources",
  iconDef: "fas fa-clipboard-check",
  links: [
    {
      linkTitle: "Best Stocks Watch List",
      linkURL: "/day-trading-watch-list-top-stocks-to-watch/",
    },
    {
      linkTitle: "Blog",
      linkURL: "/blog-posts/",
    },
    {
      linkTitle: "News",
      linkURL: "https://warriortradingnews.com/",
    },
    {
      linkTitle: "Stock Market Holidays",
      linkURL: "/stock-market-holidays/",
    },
    {
      linkTitle: "Economic Calendar",
      linkURL: "/economic-calendar/",
    },
    {
      linkTitle: "Earnings Calendar",
      linkURL: "/earnings-calendar/",
    },
    {
      linkTitle: "Day Trading Taxes",
      linkURL: "/day-trading-taxes/",
    },
    {
      linkTitle: "Swing Trading",
      linkURL: "/swing-trading/",
    },
  ]
}

export const AboutRossData = {
  title: "About Ross",
  iconDef: "fas fa-chalkboard-teacher",
  links: [
    {
      linkTitle: "Ross's Biography",
      linkURL: "/ross-cameron/",
    },
    {
      linkTitle: "2024 Earnings Statements",
      linkURL: "/verified-earnings-2024/",
    },
    {
      linkTitle: "2023 Earnings Statements",
      linkURL: "/verified-earnings-2023/",
    },
    {
      linkTitle: "2022 Earnings Statements",
      linkURL: "/verified-earnings-2022/",
    },
    {
      linkTitle: "2021 Earnings Statements",
      linkURL: "/verified-earnings-2021/",
    },
    {
      linkTitle: "2020 Earnings Statements",
      linkURL: "/verified-earnings-2020/",
    },
    {
      linkTitle: "2019 Earnings Statements",
      linkURL: "/verified-earnings-2019/",
    },
    {
      linkTitle: "2018 Earnings Statements",
      linkURL: "/verified-earnings-2018/",
    },
    {
      linkTitle: "2017 Earnings Statements",
      linkURL: "/verified-earnings-2017/",
    },
  ]
}

export const MemberStoriesData = {
  title: "Member Stories",
  iconDef: "far fa-star",
  links: [
    {
      linkTitle: "All Star Traders",
      linkURL: "/all-star-traders/",
    },
    {
      linkTitle: "Success Stories",
      linkURL: "/warrior-pro-info/success-stories/",
    },
  ]
}

export const LinksData = {
  title: "Links",
  iconDef: "fas fa-link",
  links: [
    {
      linkTitle: "YouTube",
      linkURL: "https://www.youtube.com/user/DaytradeWarrior?sub_confirmation=1",
    },
    {
      linkTitle: "Facebook",
      linkURL: "https://www.facebook.com/warriortrading/",
    },
    {
      linkTitle: "Twitter",
      linkURL: "https://twitter.com/WarriorTrading",
    },
    {
      linkTitle: "Instagram",
      linkURL: "https://www.instagram.com/warriortrading/",
    },
    {
      linkTitle: "LinkedIn",
      linkURL: "https://www.linkedin.com/company/warrior-trading",
    },
  ]
}

export const MoreData = {
  title: "More",
  iconDef: "fas fa-map-pin",
  links: [
    {
      linkTitle: "Support Portal",
      linkURL: "https://support.warriortrading.com/support/home/",
    },
    {
      linkTitle: "Contact Us",
      linkURL: "https://support.warriortrading.com/support/home/",
    },
    {
      linkTitle: "Performance Disclosure",
      linkURL: "/ross-camerons-verified-day-trading-earnings/",
    },
    {
      linkTitle: "Charitable Giving",
      linkURL: "/charitable-giving/",
    },
  ]
}

export const OtherSitesData = {
  title: "Other Sites",
  iconDef: "fas fa-globe",
  links: [
    {
      linkTitle: "Warrior Trading News",
      linkURL: "https://warriortradingnews.com/",
    },
    {
      linkTitle: "RossCameron.com",
      linkURL: "https://rosscameron.com/",
    },
  ]
}

export const FAQData = {
  title: "FAQ",
  iconDef: "far fa-question-circle",
  links: [
    {
      linkTitle: "All FAQ",
      linkURL: "/faq/",
    },
    {
      linkTitle: "How much money do I need to start trading?",
      linkURL: "/how-much-money-do-you-need-to-day-trade/",
    },
  ]
}

export const CryptoQuotesData = {
  title: "Crypto Quotes",
  iconDef: "fas fa-fire",
  links: [
    {
      linkTitle: "Bitcoin (BTC)",
      linkURL: "/quote/~btcusd/",
    },
    {
      linkTitle: "Ethereum (ETH)",
      linkURL: "/quote/~ethusd/",
    },
    {
      linkTitle: "Dogecoin (DOGE)",
      linkURL: "/quote/~dogeusd/",
    },
    {
      linkTitle: "Cardano (ADA)",
      linkURL: "/quote/~adausd/",
    },
  ]
}

export const BrokerRebatesData = {
  title: "Broker Rebates",
  iconDef: "fas fa-dollar-sign",
  links: [
    {
      linkTitle: "CMEG",
      linkURL: "/cmeg-broker-rebate-program/",
    },
    {
      linkTitle: "LightSpeed",
      linkURL: "/lightspeed-broker-rebate-program/",
    },
  ]
}

export const StoriesData = {
  title: "Stories",
  iconDef: "fas fa-book-open",
  links: [
    {
      linkTitle: "Student Success Stories",
      linkURL: "/day-trading-success-stories/",
    },
  ]
}

